import { Suspense } from 'react';

function MainLayout({ children }: { children?: React.ReactNode }) {
    return <Suspense fallback="">{children}</Suspense>;
}

export default MainLayout;
